<template>
  <div class="progress-bar">
    <div :style='progressStyle' :class="['progress']" :value="value" max="100"></div>
  </div>
</template>

<script>
export default {
  name: 'progress-bar',
  props: ['value'],
  inject: ['theme'],
  computed: {
    progressWidth () {
      return this.value + '%'
    },
    progressStyle () {
      return {
        width: this.progressWidth,
        backgroundColor: this.theme.progressBar.backgroundColor || this.theme.accent.backgroundColor
      }
    }
  }
}
</script>

<style lang='scss' scoped>
@import '../scss/main';
  .progress-bar {
    z-index: 2;
    background-color: #f5f5f5;
    position:fixed;
    top:0;
    left: 0;
    width:100%;
    height:1.75%;
    .progress {
      height:100%;
    }
    & > div {
      background-color: #888888;
    }
  }
  progress {
    position:absolute;
    top:0;
    left: 0;
    width:100%;
    -webkit-appearance:none;
    border-radius:0;
    border:none;
    height:100%;
  }
</style>
